<template>
  <div class="space-y-6">
    <!-- 购物车为空 -->
    <div v-if="cartItems.length === 0" class="bg-white rounded-lg shadow-elevation-1 p-12 text-center">
      <div class="text-neutral-300 text-6xl mb-6">
        <i class="fa fa-shopping-cart"></i>
      </div>
      <h3 class="text-xl font-medium mb-4">您的购物车是空的</h3>
      <p class="text-neutral-500 mb-8">快去挑选心仪的商品吧！</p>
      <router-link to="/" class="inline-block bg-primary hover:bg-primary/90 text-white px-8 py-3 rounded-lg transition-colors">
        去购物
      </router-link>
    </div>

    <!-- 购物车有商品 -->
    <div v-else class="space-y-6">
      <!-- 购物车列表 -->
      <div class="bg-white rounded-lg shadow-elevation-1 overflow-hidden">
        <div class="grid grid-cols-12 p-4 border-b border-neutral-200 text-sm font-medium">
          <div class="col-span-1">选择</div>
          <div class="col-span-4">商品</div>
          <div class="col-span-2">单价</div>
          <div class="col-span-2">数量</div>
          <div class="col-span-2">小计</div>
          <div class="col-span-1">操作</div>
        </div>
        
        <div class="space-y-1" v-for="item in cartItems" :key="item.id">
          <div class="grid grid-cols-12 p-4 items-center border-b border-neutral-200 last:border-0">
            <div class="col-span-1">
              <input type="checkbox" class="rounded text-primary" checked>
            </div>
            <div class="col-span-4 flex items-center">
              <img :src="item.image" alt="商品图片" class="w-16 h-16 object-cover rounded mr-3">
              <div class="text-sm">
                <h4 class="line-clamp-2">{{ item.name }}</h4>
                <p class="text-neutral-500 text-xs mt-1">{{ item.specs }}</p>
              </div>
            </div>
            <div class="col-span-2 text-sm">¥{{ item.price }}</div>
            <div class="col-span-2">
              <div class="flex items-center w-full max-w-[100px]">
                <button class="w-6 h-6 border border-neutral-200 flex items-center justify-center hover:border-primary transition-colors text-xs" @click="decreaseQuantity(item)">
                  <i class="fa fa-minus"></i>
                </button>
                <input type="number" v-model="item.quantity" min="1" class="w-8 h-6 border-t border-b border-neutral-200 text-center focus:outline-none text-xs">
                <button class="w-6 h-6 border border-neutral-200 flex items-center justify-center hover:border-primary transition-colors text-xs" @click="increaseQuantity(item)">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="col-span-2 text-sm font-medium">¥{{ item.price * item.quantity }}</div>
            <div class="col-span-1">
              <button class="text-neutral-400 hover:text-danger transition-colors text-xs" @click="removeItem(item.id)">
                <i class="fa fa-trash-o"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 结算区域 -->
      <div class="bg-white rounded-lg shadow-elevation-1 p-6">
        <div class="flex flex-col md:flex-row md:justify-between md:items-center">
          <div class="flex items-center mb-4 md:mb-0">
            <label class="flex items-center mr-6 cursor-pointer">
              <input type="checkbox" class="rounded text-primary" checked>
              <span class="ml-2 text-sm">全选</span>
            </label>
            <button class="text-neutral-500 hover:text-danger transition-colors text-sm" @click="clearCart">
              清空购物车
            </button>
          </div>
          
          <div class="flex items-center">
            <div class="text-right mr-6">
              <div class="text-sm mb-1">
                <span class="text-neutral-500">已选商品：</span>
                <span class="font-medium">{{ totalCount }}件</span>
              </div>
              <div class="text-lg">
                <span class="text-neutral-500">合计：</span>
                <span class="text-primary font-bold">¥{{ totalAmount }}</span>
              </div>
            </div>
            
            <router-link to="/checkout" class="bg-primary hover:bg-primary/90 text-white font-medium py-2 px-8 rounded-lg transition-colors">
              去结算
            </router-link>
          </div>
        </div>
      </div>
      
      <!-- 猜你喜欢 -->
      <div>
        <h3 class="text-lg font-medium mb-4">猜你喜欢</h3>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div class="bg-white rounded-lg shadow-elevation-1 overflow-hidden product-card-hover">
            <img src="https://picsum.photos/400/400?random=40" alt="推荐商品" class="w-full h-48 object-cover">
            <div class="p-3">
              <h4 class="text-sm font-medium line-clamp-2 mb-2">Apple AirPods Pro 第二代 主动降噪蓝牙耳机</h4>
              <div class="flex items-center justify-between">
                <span class="text-primary font-bold text-sm">¥1799</span>
                <button class="bg-primary/10 hover:bg-primary/20 text-primary text-xs px-2 py-1 rounded transition-colors">
                  加入购物车
                </button>
              </div>
            </div>
          </div>
          
          <div class="bg-white rounded-lg shadow-elevation-1 overflow-hidden product-card-hover">
            <img src="https://picsum.photos/400/400?random=41" alt="推荐商品" class="w-full h-48 object-cover">
            <div class="p-3">
              <h4 class="text-sm font-medium line-clamp-2 mb-2">Apple Watch Series 9 智能手表 GPS款 45毫米</h4>
              <div class="flex items-center justify-between">
                <span class="text-primary font-bold text-sm">¥2999</span>
                <button class="bg-primary/10 hover:bg-primary/20 text-primary text-xs px-2 py-1 rounded transition-colors">
                  加入购物车
                </button>
              </div>
            </div>
          </div>
          
          <div class="bg-white rounded-lg shadow-elevation-1 overflow-hidden product-card-hover">
            <img src="https://picsum.photos/400/400?random=42" alt="推荐商品" class="w-full h-48 object-cover">
            <div class="p-3">
              <h4 class="text-sm font-medium line-clamp-2 mb-2">Apple MagSafe 无线充电器 15W 适用于iPhone</h4>
              <div class="flex items-center justify-between">
                <span class="text-primary font-bold text-sm">¥329</span>
                <button class="bg-primary/10 hover:bg-primary/20 text-primary text-xs px-2 py-1 rounded transition-colors">
                  加入购物车
                </button>
              </div>
            </div>
          </div>
          
          <div class="bg-white rounded-lg shadow-elevation-1 overflow-hidden product-card-hover">
            <img src="https://picsum.photos/400/400?random=43" alt="推荐商品" class="w-full h-48 object-cover">
            <div class="p-3">
              <h4 class="text-sm font-medium line-clamp-2 mb-2">Apple 20W USB-C 电源适配器 快速充电器</h4>
              <div class="flex items-center justify-between">
                <span class="text-primary font-bold text-sm">¥149</span>
                <button class="bg-primary/10 hover:bg-primary/20 text-primary text-xs px-2 py-1 rounded transition-colors">
                  加入购物车
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cart',
  data() {
    return {
      cartItems: [
        {
          id: 1,
          name: 'Apple iPhone 15 Pro 256GB 原色钛金属',
          price: 7999,
          quantity: 1,
          image: 'https://picsum.photos/400/400?random=10',
          specs: '颜色：原色钛金属 | 容量：256GB'
        },
        {
          id: 2,
          name: '华为 MateBook X Pro 2024款 14.2英寸笔记本电脑',
          price: 8999,
          quantity: 1,
          image: 'https://picsum.photos/400/400?random=11',
          specs: '颜色：深空灰 | 配置：i7/16GB/1TB'
        },
        {
          id: 3,
          name: 'Nike Air Jordan 1 复古高帮篮球鞋 男女同款',
          price: 899,
          quantity: 2,
          image: 'https://picsum.photos/400/400?random=12',
          specs: '颜色：黑白 | 尺码：42'
        }
      ]
    }
  },
  computed: {
    totalCount() {
      return this.cartItems.reduce((total, item) => total + item.quantity, 0)
    },
    totalAmount() {
      return this.cartItems.reduce((total, item) => total + (item.price * item.quantity), 0)
    }
  },
  methods: {
    increaseQuantity(item) {
      item.quantity++
    },
    decreaseQuantity(item) {
      if (item.quantity > 1) {
        item.quantity--
      }
    },
    removeItem(id) {
      this.cartItems = this.cartItems.filter(item => item.id !== id)
      this.$bus.$emit('showMessage', '商品已从购物车移除！')
    },
    clearCart() {
      if (confirm('确定要清空购物车吗？')) {
        this.cartItems = []
      }
    }
  }
}
</script>